import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorTemplate, {
  ErrorTemplateCode,
} from 'web-library/stories/template/ErrorTemplate/ErrorTemplate';
import Link from 'web-library/stories/atom/Link/Link';
import ErrorPageTitle from '../../components/errors/ErrorPageTitle';

import {typographyTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  link: {
     ...typographyTheme(theme, 'h4'),
  },
}));

const Generic = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <ErrorTemplate
      errorCode={'generic' as ErrorTemplateCode}
      title={<ErrorPageTitle label={t('components->>GenericError.DoNotHaveAccessThisFeature')} />}
      subtitle={
        <Link className={classes.link} href="/" withUnderline>
          {t('components->>GenericError.BackToHomepage')}
        </Link>
      }
    />
  );
};

export default Generic;
